import * as cventPresets from './cventPresets';

export const presetThemes = {
  ...cventPresets
};
